// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true, es6:true*/
(function(){
let define;
let is_node = typeof module=='object' && module.exports;
if (!is_node)
    define = self.define;
else
    define = require('../../../util/require_node.js').define(module, '../');
define(['lodash4'], _=>{

const E = {};

E.validate_file = (file, opt={})=>{
    let {max_size = 1024*1024, supported_types = [], required = true} = opt;
    if (!file && !required)
        return null;
    let errors = {};
    if (!file && required)
        return {required: true};
    if (supported_types.length)
    {
        let fname = file.name || '';
        let mime_type = file.type;
        let ext = fname.slice((Math.max(0,
            fname.lastIndexOf('.')) || Infinity) + 1);
        ext = ext&&`.${ext}`;
        if (supported_types.findIndex(t=>t==mime_type||t==ext)==-1)
            errors.type = ext;
    }
    if (file.size>max_size)
        errors.max_size = file.size;
    return _.isEmpty(errors) ? null : errors;
};

let complex_types = {
    json: 'application/json',
    html: 'text/html',
    jpeg: 'image/jpeg',
    png: 'image/png',
};

E.get_allowed_types= (types_array, opt = {})=>{
    return types_array.reduce((acc, t)=>{
        if (complex_types[t] && !opt.exclude_mime_types)
            acc.push(complex_types[t]);
        else
            acc.push('.'+t, '.'+t.toUpperCase());
        return acc;
    }, []);
};

return E; }); }()); // eslint-disable-line

